import {Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as html2pdf from "html2pdf.js";
import { Router } from "@angular/router";
import { LocalStorageService } from "ng2-webstorage";
import { MessageService } from 'primeng/components/common/messageservice';
import {ConfirmationService, Paginator} from 'primeng/primeng';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.css']
})

export class StudentProfileComponent implements OnInit {
  @ViewChild('paginator') paginator: Paginator
  private routeSubscription: Subscription;
  public Sections: any;
  public spinnershow: boolean = false;
  public data: any;
  public data2: any;
  public data3: any;
  public data4: any;
  public siblings: any;
  public schoolId: any;
  public isUserSchoolAdmin: boolean;
  public isAdmin: boolean;
  public isUpdating: boolean = false;
  public isPrinting: boolean = false;
  public isHidingButtons: boolean = false;
  public isMissingAPIFieldsShowing: boolean = false;
  public acedemic_year_id: number = 0;
  base64Image:any;

  editAdminssionNumber: boolean = false; // Define the variable
  editGrade: boolean = false; // Define the variable
  editSection: boolean = false; // Define the variable
  editDateOfBirth: boolean = false; // Define the variable
  editEmailAddress: boolean = false; // Define the variable
  editAddress: boolean = false; // Define the variable
  editHouse: boolean = false; // Define the variable
  editHosteler: boolean = false; // Define the variable
  editReligion: boolean = false; // Define the variable
  editMedium: boolean = false; // Define the variable
  editAdmissionYear: boolean = false; // Define the variable
  editLeavingYear: boolean = false; // Define the variable
  editFatheerContactNo: boolean = false; // Define the variable
  editFatherEmail: boolean = false; // Define the variable
  editMotherContactNo: boolean = false; // Define the variable
  editMotherEmail: boolean = false; // Define the variable
  editGuardianName: boolean = false; // Define the variable
  editGuardianContactNo: boolean = false; // Define the variable
  editGuardianEmail: boolean = false; // Define the variable
  editContact1: boolean = false; // Define the variable
  editRelationship1: boolean = false; // Define the variable
  editMobileNo1: boolean = false; // Define the variable
  editContact2: boolean = false; // Define the variable
  editRelationship2: boolean = false; // Define the variable
  editMobileNo2: boolean = false; // Define the variable
  editIsFatherPastStudent: boolean = false; // Define the variable
  editIsMotherPastStudent: boolean = false; // Define the variable
  editBloodGroup: boolean = false; // Define the variable
  editMedicalConditions: boolean = false; // Define the variable
  editSpecialNeeds: boolean = false; // Define the variable
  editPrefectship: boolean = false; // Define the variable
  editScholarship: boolean = false; // Define the variable
  editDiscipline: boolean = false; // Define the variable
  editSportName: boolean = false; // Define the variable
  editClubName: boolean = false; // Define the variable
  editOther: boolean = false; // Define the variable





  public uploaded_image: File = null;

  tempSection: any;
  mappedData: any;
  selectedGrade1: any;
  selectedSection1: any;
  sectionList1: any;
  selectedYear1: any;
  child_id: any;

  constructor(private noticeboardService: NoticeboardService, private localStorage: LocalStorageService, private messageService: MessageService, private confirmationService: ConfirmationService, private parentchildservice: ParentChildService, private router: Router,private route: ActivatedRoute, private dataAnalyticsService: DataAnalyticsService) {
    this.Sections =null;
    // this.Sections=true;

  }
  ngOnInit() {
    this.isAdmin = this.localStorage.retrieve("IsSchoolAdminUser");
    this.getClassSection();
    this.route.queryParams.subscribe(params => {
      this.acedemic_year_id = params['acyid'];
      this.child_id = params['child_id'];
    });
    this.isUserSchoolAdmin = this.localStorage.retrieve("IsSchoolAdminUser");
    if(!this.isUserSchoolAdmin){
      // this.router.navigate(['parentchild/View']);
      this.getHieduChildsDetails(this.child_id, this.acedemic_year_id);
    }else{
      this.getHieduChildsDetails(this.child_id, this.acedemic_year_id);
    }
  }


  async handleReaderLoaded(e) :Promise<boolean>{
    return  new Promise<boolean>(resolve => {
      console.log(e.target.result);
      this.base64Image = 'data:image/png;base64,' + btoa(e.target.result);
      console.log(this.base64Image);
      resolve(true)
    })
  }


  async handleImageUpload(event: any){

    const file: File = event.target.files[0];
    const reader: FileReader = new FileReader();

    if (file) {
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      var self =this;
      reader.onload = ()=>{
        // self.base64Image=reader.result.toString();
        this.base64Image = file;
        this.updateField('StudentImageFile');
      }

    }


    // if (file) {
    //   this.uploaded_image = file;
    // }
    console.log(this.uploaded_image);
    // this.updateField('StudentImageFile');
  }

  PrintPdf() {
    this.isHidingButtons = true;
    this.isPrinting = true;

    const options = {
      filename: this.data.ChildFirstName + " " + this.data.ChildLastName,
      margin: [15, 15, 15, 15],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      html2canvas: {
        dpi: 192,
        scale: 2,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('for_print')

    html2pdf()
      .from(content)
      .set(options)
      .save()
      .then(() => {
        this.isPrinting = false;
        this.isHidingButtons = false;
      });
  }

  navigateChild(t){
    // console.log('press');
    this.router.navigate(['parent/student-profile'], { queryParams: { child_id: t, acyid: this.acedemic_year_id } });
    // this.router.navigate(['parent/student-profile' + t]).then(() => {
    //   this.getHieduChildsDetails(t, this.acedemic_year_id);
    //   window.scrollTo({ top: 0, behavior: 'smooth' });
    // });;
    this.getHieduChildsDetails(t, this.acedemic_year_id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  isNumeric(str) {
    return !isNaN(str) && !isNaN(parseFloat(str))
  }

  ContactNoChanged(e,f,g){
    if(e.length >= 1 && e.substring(0, 1) == "0"){
      e = "+94" + e.substring(1);
    }
    if(e.length >= 2 && (e.substring(0, 2) != "94" && e.substring(0, 2) != "+9")){
      e = "+94" + e.substring(2);
    }
    if(e.length >= 3 && e.substring(0, 3) != "+94"){
      e = "+94" + e.substring(3);
    }
    if(e.length >= 2 && e.substring(0, 2) == "94"){
      e = "+" + e;
    }

    e = e.replace(" ", "").replace("e", "");

    this.data[f] = e;
    if(e.length == 12 && e.substring(0, 3) == "+94" && e.substring(3, 4) != "0" && this.isNumeric(Number(e.substring(1)))){
      this.data[g] = true;
    }else{
      this.data[g] = false;
    }
  }


  editField(fieldName: string) {
    this.editAdminssionNumber = false;
    this.editGrade = false;
    this.editSection = false;
    this.editDateOfBirth = false;
    this.editEmailAddress = false;
    this.editAddress = false;
    this.editHouse = false;
    this.editHosteler = false;
    this.editReligion = false;
    this.editMedium = false;
    this.editAdmissionYear = false;
    this.editLeavingYear = false;
    this.editFatheerContactNo = false;
    this.editFatherEmail = false;
    this.editMotherContactNo = false;
    this.editMotherEmail = false;
    this.editGuardianName = false;
    this.editGuardianContactNo = false;
    this.editGuardianEmail = false;
    this.editContact1 = false;
    this.editRelationship1 = false;
    this.editMobileNo1 = false;
    this.editContact2 = false;
    this.editRelationship2 = false;
    this.editMobileNo2 = false;
    this.editIsFatherPastStudent = false;
    this.editIsMotherPastStudent = false;
    this.editBloodGroup = false;
    this.editMedicalConditions = false;
    this.editSpecialNeeds = false;
    this.editPrefectship = false;
    this.editScholarship = false;
    this.editDiscipline = false;
    this.editSportName = false;
    this.editClubName = false;
    this.editOther = false;

    if (fieldName === 'editAdminssionNumber') {
      this.editAdminssionNumber = true;
    }
    if (fieldName === 'editGrade') {
      this.editGrade = true;
    }
    if (fieldName === 'editSection') {
      this.editSection = true;
    }
    if (fieldName === 'editDateOfBirth') {
      this.editDateOfBirth = true;
    }
    if (fieldName === 'editEmailAddress') {
      this.editEmailAddress = true;
    }
    if (fieldName === 'editAddress') {
      this.editAddress = true;
    }
    if (fieldName === 'editHouse') {
      this.editHouse = true;
    }
    if (fieldName === 'editHosteler') {
      this.editHosteler = true;
    }
    if (fieldName === 'editReligion') {
      this.editReligion = true;
    }
    if (fieldName === 'editMedium') {
      this.editMedium = true;
    }
    if (fieldName === 'editAdmissionYear') {
      this.editAdmissionYear = true;
    }
    if (fieldName === 'editLeavingYear') {
      this.editLeavingYear = true;
    }
    if (fieldName === 'editFatheerContactNo') {
      this.editFatheerContactNo = true;
    }
    if (fieldName === 'editFatherEmail') {
      this.editFatherEmail = true;
    }
    if (fieldName === 'editMotherContactNo') {
      this.editMotherContactNo = true;
    }
    if (fieldName === 'editMotherEmail') {
      this.editMotherEmail = true;
    }
    if (fieldName === 'editGuardianName') {
      this.editGuardianName = true;
    }
    if (fieldName === 'editGuardianContactNo') {
      this.editGuardianContactNo = true;
    }
    if (fieldName === 'editGuardianEmail') {
      this.editGuardianEmail = true;
    }
    if (fieldName === 'editContact1') {
      this.editContact1 = true;
    }
    if (fieldName === 'editRelationship1') {
      this.editRelationship1 = true;
    }
    if (fieldName === 'editMobileNo1') {
      this.editMobileNo1 = true;
    }
    if (fieldName === 'editContact2') {
      this.editContact2 = true;
    }
    if (fieldName === 'editRelationship2') {
      this.editRelationship2 = true;
    }
    if (fieldName === 'editMobileNo2') {
      this.editMobileNo2 = true;
    }
    if (fieldName === 'editIsFatherPastStudent') {
      this.editIsFatherPastStudent = true;
    }
    if (fieldName === 'editIsMotherPastStudent') {
      this.editIsMotherPastStudent = true;
    }
    if (fieldName === 'editBloodGroup') {
      this.editBloodGroup = true;
    }
    if (fieldName === 'editMedicalConditions') {
      this.editMedicalConditions = true;
    }
    if (fieldName === 'editSpecialNeeds') {
      this.editSpecialNeeds = true;
    }
    if (fieldName === 'editPrefectship') {
      this.editPrefectship = true;
    }
    if (fieldName === 'editScholarship') {
      this.editScholarship = true;
    }
    if (fieldName === 'editDiscipline') {
      this.editDiscipline = true;
    }
    if (fieldName === 'editSportName') {
      this.editSportName = true;
    }
    if (fieldName === 'editClubName') {
      this.editClubName = true;
    }
    if (fieldName === 'editOther') {
      this.editOther = true;
    }
  }



  discardField(fieldName: string) {
    if (fieldName === 'editAdminssionNumber') {
      this.editAdminssionNumber = false;
    }
    if (fieldName === 'editGrade') {
      this.editGrade = false;
    }
    if (fieldName === 'editSection') {
      this.editSection = false;
    }
    if (fieldName === 'editDateOfBirth') {
      this.editDateOfBirth = false;
    }
    if (fieldName === 'editEmailAddress') {
      this.editEmailAddress = false;
    }
    if (fieldName === 'editAddress') {
      this.editAddress = false;
    }
    if (fieldName === 'editHouse') {
      this.editHouse = false;
    }
    if (fieldName === 'editHosteler') {
      this.editHosteler = false;
    }
    if (fieldName === 'editReligion') {
      this.editReligion = false;
    }
    if (fieldName === 'editMedium') {
      this.editMedium = false;
    }
    if (fieldName === 'editAdmissionYear') {
      this.editAdmissionYear = false;
    }
    if (fieldName === 'editLeavingYear') {
      this.editLeavingYear = false;
    }
    if (fieldName === 'editFatheerContactNo') {
      this.editFatheerContactNo = false;
    }
    if (fieldName === 'editFatherEmail') {
      this.editFatherEmail = false;
    }
    if (fieldName === 'editMotherContactNo') {
      this.editMotherContactNo = false;
    }
    if (fieldName === 'editMotherEmail') {
      this.editMotherEmail = false;
    }
    if (fieldName === 'editGuardianName') {
      this.editGuardianName = false;
    }
    if (fieldName === 'editGuardianContactNo') {
      this.editGuardianContactNo = false;
    }
    if (fieldName === 'editGuardianEmail') {
      this.editGuardianEmail = false;
    }
    if (fieldName === 'editContact1') {
      this.editContact1 = false;
    }
    if (fieldName === 'editRelationship1') {
      this.editRelationship1 = false;
    }
    if (fieldName === 'editMobileNo1') {
      this.editMobileNo1 = false;
    }
    if (fieldName === 'editContact2') {
      this.editContact2 = false;
    }
    if (fieldName === 'editRelationship2') {
      this.editRelationship2 = false;
    }
    if (fieldName === 'editMobileNo2') {
      this.editMobileNo2 = false;
    }
    if (fieldName === 'editIsFatherPastStudent') {
      this.editIsFatherPastStudent = false;
    }
    if (fieldName === 'editIsMotherPastStudent') {
      this.editIsMotherPastStudent = false;
    }
    if (fieldName === 'editBloodGroup') {
      this.editBloodGroup = false;
    }
    if (fieldName === 'editMedicalConditions') {
      this.editMedicalConditions = false;
    }
    if (fieldName === 'editSpecialNeeds') {
      this.editSpecialNeeds = false;
    }
    if (fieldName === 'editPrefectship') {
      this.editPrefectship = false;
    }
    if (fieldName === 'editScholarship') {
      this.editScholarship = false;
    }
    if (fieldName === 'editDiscipline') {
      this.editDiscipline = false;
    }
    if (fieldName === 'editSportName') {
      this.editSportName = false;
    }
    if (fieldName === 'editClubName') {
      this.editClubName = false;
    }
    if (fieldName === 'editOther') {
      this.editOther = false;
    }
  }
  // editField(t){
  //   if(this.hasOwnProperty(t)){
  //     this[t] = !this[t];
  //   }else{
  //     this[t] = true;
  //   }
  // }

  formatDateSend(date) {
    var d = new Date(date);

    return d.toISOString();
  }

  formatDateReceive(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  updateField(fieldName: string){
    if (fieldName === 'editAdminssionNumber') {
      this.editAdminssionNumber = false;
    }
    if (fieldName === 'editGrade') {
      this.editGrade = false;
    }
    if (fieldName === 'editSection') {
      this.editSection = false;
    }
    if (fieldName === 'editDateOfBirth') {
      this.editDateOfBirth = false;
    }
    if (fieldName === 'editEmailAddress') {
      this.editEmailAddress = false;
    }
    if (fieldName === 'editAddress') {
      this.editAddress = false;
    }
    if (fieldName === 'editHouse') {
      this.editHouse = false;
    }
    if (fieldName === 'editHosteler') {
      this.editHosteler = false;
    }
    if (fieldName === 'editReligion') {
      this.editReligion = false;
    }
    if (fieldName === 'editMedium') {
      this.editMedium = false;
    }
    if (fieldName === 'editAdmissionYear') {
      this.editAdmissionYear = false;
    }
    if (fieldName === 'editLeavingYear') {
      this.editLeavingYear = false;
    }
    if (fieldName === 'editFatheerContactNo') {
      this.editFatheerContactNo = false;
    }
    if (fieldName === 'editFatherEmail') {
      this.editFatherEmail = false;
    }
    if (fieldName === 'editMotherContactNo') {
      this.editMotherContactNo = false;
    }
    if (fieldName === 'editMotherEmail') {
      this.editMotherEmail = false;
    }
    if (fieldName === 'editGuardianName') {
      this.editGuardianName = false;
    }
    if (fieldName === 'editGuardianContactNo') {
      this.editGuardianContactNo = false;
    }
    if (fieldName === 'editGuardianEmail') {
      this.editGuardianEmail = false;
    }
    if (fieldName === 'editContact1') {
      this.editContact1 = false;
    }
    if (fieldName === 'editRelationship1') {
      this.editRelationship1 = false;
    }
    if (fieldName === 'editMobileNo1') {
      this.editMobileNo1 = false;
    }
    if (fieldName === 'editContact2') {
      this.editContact2 = false;
    }
    if (fieldName === 'editRelationship2') {
      this.editRelationship2 = false;
    }
    if (fieldName === 'editMobileNo2') {
      this.editMobileNo2 = false;
    }
    if (fieldName === 'editIsFatherPastStudent') {
      this.editIsFatherPastStudent = false;
    }
    if (fieldName === 'editIsMotherPastStudent') {
      this.editIsMotherPastStudent = false;
    }
    if (fieldName === 'editBloodGroup') {
      this.editBloodGroup = false;
    }
    if (fieldName === 'editMedicalConditions') {
      this.editMedicalConditions = false;
    }
    if (fieldName === 'editSpecialNeeds') {
      this.editSpecialNeeds = false;
    }
    if (fieldName === 'editPrefectship') {
      this.editPrefectship = false;
    }
    if (fieldName === 'editScholarship') {
      this.editScholarship = false;
    }
    if (fieldName === 'editDiscipline') {
      this.editDiscipline = false;
    }
    if (fieldName === 'editSportName') {
      this.editSportName = false;
    }
    if (fieldName === 'editClubName') {
      this.editClubName = false;
    }
    if (fieldName === 'editOther') {
      this.editOther = false;
    }
    this.isUpdating = true;
    this.spinnershow = true;
    var y = this;
    let x = y.data;

    const z = {
      'RegisterationNumber' : y.data.StudentDetails.RegisterationNumber,
      'Standard' : y.data.StudentDetails.Standard,
      'Section' : y.data.StudentDetails.Section,
      'Schoolid' : y.data.StudentDetails.Schoolid,
      'AcademicYearName' : y.data.StudentDetails.AcademicYearName,
      'AcademicYearId' : y.data.StudentDetails.AcademicYearId,
      'ChildFirstName' : y.data.StudentDetails.ChildFirstName,
      'ChildLastName' : y.data.StudentDetails.ChildLastName,
      'ChildId' : y.data.StudentDetails.ChildId,
      'Inactivestudent' : y.data.StudentDetails.Inactivestudent,
      'ChildSectionId' : y.data.StudentDetails.ChildSectionId,
      'Childcreateddate' : y.data.StudentDetails.Childcreateddate,
      'IsOtherParentSMSUser' : y.data.StudentDetails.IsOtherParentSMSUser,
      'Issmsuser' : y.data.StudentDetails.Issmsuser,
      'ParentPortalEnabled' : y.data.StudentDetails.ParentPortalEnabled,
      'Parentcreateddate' : y.data.StudentDetails.Parentcreateddate,
      'ParentsName' : y.data.StudentDetails.ParentsName,
      'ParentsGender' : y.data.StudentDetails.ParentsGender,
      'ParentsRelation' : y.data.StudentDetails.ParentsRelation,
      'School' : y.data.StudentDetails.School,
      'schoolid' : y.data.StudentDetails.schoolid,
      'SectionId' : y.data.StudentDetails.SectionId,
      'StandardId' : y.data.StudentDetails.StandardId,
      'id' : y.data.StudentDetails.id,
      'schoollogo' : y.data.StudentDetails.schoollogo,
      'DateOfBirth': this.formatDateSend(y.data.StudentDetails.DateOfBirth),
      'EmailAddress' : y.data.StudentDetails.EmailAddress,
      'HomeAddress' : y.data.StudentDetails.HomeAddress,
      'House' : y.data.StudentDetails.House,
      'Hosteler' : y.data.StudentDetails.Hosteler,
      'Religion' : y.data.StudentDetails.Religion,
      'Medium' : y.data.StudentDetails.Medium,
      'AdmissionYear' : y.data.StudentDetails.AdmissionYear,
      'LeavingYear' : y.data.StudentDetails.LeavingYear,
      'GuardianName' : y.data.StudentDetails.GuardianName,
      'GuardianContactNo' : y.data.StudentDetails.GuardianContactNo,
      'GuardianEmail' : y.data.StudentDetails.GuardianEmail,
      'Contact1' : y.data.StudentDetails.Contact1,
      'Relationship1' : y.data.StudentDetails.Relationship1,
      'MobileNo1' : y.data.StudentDetails.MobileNo1,
      'Contact2' : y.data.StudentDetails.Contact2,
      'Relationship2' : y.data.StudentDetails.Relationship2,
      'MobileNo2' : y.data.StudentDetails.MobileNo2,
      'IsFatherPastStudent' : y.data.StudentDetails.IsFatherPastStudent,
      'IsMotherPastStudent' : y.data.StudentDetails.IsMotherPastStudent,
      'BloodGroup' : y.data.StudentDetails.BloodGroup,
      'MedicalConditions' : y.data.StudentDetails.MedicalConditions,
      'SpecialNeeds' : y.data.StudentDetails.SpecialNeeds,
      'Prefectship' : y.data.StudentDetails.Prefectship,
      'Scholarship' : y.data.StudentDetails.Scholarship,
      'Discipline' : y.data.StudentDetails.Discipline,
      'SportName' : y.data.StudentDetails.SportName,
      'ClubName' : y.data.StudentDetails.ClubName,
      'Other' : y.data.StudentDetails.Other,
    }

    console.log(z);

    if (this.base64Image) {
      z['StudentImageFile'] = this.base64Image;
      z['ImageBase64'] = this.base64Image;
    }else {
      z['StudentImageLink'] = y.data.StudentDetails.StudentImageLink
    }


    this.parentchildservice.updateHiChildInfoQuanta(z).finally(() => { y.isUpdating = false; y.spinnershow = false; }).subscribe(
      response => {
        y.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Updated Successfully' });
        // y[t] = false;
        console.log("success", response);
        // const childId = this.route.snapshot.params['child_id'];
        this.base64Image = null;
        this.getHieduChildsDetails(this.child_id, this.acedemic_year_id);

      },
      error => {
        if(error == undefined){
          y.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Updated Successfully' });
          // y[t] = false;
          console.log("success", error);
        }else{
          console.log("error", error);
        }
      });
  }

  HieduStudentDelete(childId){
    this.parentchildservice.deleteHiChildInfo(childId)
      .subscribe(data=>{
        console.log("HieduStudentDelete");
      })
  }

  private getHieduChildsDetails(id, acedemic_year_id) {
    // console.log(this.child_id);
    this.spinnershow = true;
    this.data = {ChildFirstName: '', ChildLastName: ''};
    let data2 = {FirstName: '', Id: null, LastName: '', Sectionname: '', Standardnname: ''};
    this.parentchildservice.getHIeduChildInfoQuanta(id, acedemic_year_id).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        // console.log(response);
        //  console.log("getHieduChildsDetails response", response);
        this.data = response;
        // this.base64Image = this.data.StudentDetails.ImageBase64;
        console.log("getHieduChildsDetails", this.data);

        if(this.data.StudentDetails['ParentsGender'] == "Female"){
          this.data.StudentDetails['FatherName'] = this.data.StudentDetails['OtherParentFirstName'] + " " + this.data.StudentDetails['OtherParentLastName'];
          this.data.StudentDetails['FatheerContactNo'] = this.data.StudentDetails['OtherParentPhoneNumber'];
          this.data.StudentDetails['FatherEmail'] = this.data.StudentDetails['OtherParentEmailAddress'];
          this.data.StudentDetails['FatherSMSUser'] = this.data.StudentDetails['IsOtherParentSMSUser'] ? true : false;
          this.data.StudentDetails['MotherName'] = this.data.StudentDetails['ParentsName'];
          this.data.StudentDetails['MotherContactNo'] = this.data.StudentDetails['PhoneNumber'];
          this.data.StudentDetails['MotherEmail'] = this.data.StudentDetails['EmailAddress'];
          this.data.StudentDetails['MotherSMSUser'] = this.data.StudentDetails['Issmsuser'];
        }else{
          this.data.StudentDetails['FatherName'] = this.data.StudentDetails['ParentsName'];
          this.data.StudentDetails['FatheerContactNo'] = this.data.StudentDetails['PhoneNumber'];
          this.data.StudentDetails['FatherEmail'] = this.data.StudentDetails['EmailAddress'];
          this.data.StudentDetails['FatherSMSUser'] = this.data.StudentDetails['Issmsuser'];
          this.data.StudentDetails['MotherName'] = this.data.StudentDetails['OtherParentFirstName'] + " " + this.data.StudentDetails['OtherParentLastName'];
          this.data.StudentDetails['MotherContactNo'] = this.data.StudentDetails['OtherParentPhoneNumber'];
          this.data.StudentDetails['MotherEmail'] = this.data.StudentDetails['OtherParentEmailAddress'];
          this.data.StudentDetails['MotherSMSUser'] = this.data.StudentDetails['IsOtherParentSMSUser'] ? true : false;
        }


        const standard = this.mappedData.find(std => std.standardId === this.data.StudentDetails.StandardId);
        this.sectionList1 = standard.Sections;
        console.log(this.sectionList1);


        this.sectionList1.sort((a, b) => {
          if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
            return -1;
          }
          if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
            return 1;
          }
          return 0;
        });

        // console.log(id);
        // console.log(this.data.StudentDetails.id);
        this.schoolId = this.localStorage.retrieve("SchoolId");
        // console.log(this.schoolId);

        this.getSiblingInfo(id,this.data.StudentDetails.id,this.schoolId);
      },
      error => {
        console.log(error);
      });
  }

  private getSiblingInfo(childid,parentid,schoolid) {
    this.spinnershow = true;
    this.parentchildservice.getSiblingInfoQuanta(childid,parentid,schoolid).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        console.log("getSiblingInfo", response);
        if(response && response['items'] && response['items'][0]){
          this.siblings = response['items'];
          console.log(this.siblings);
          this.siblings = response['items'].filter(sibling => sibling.ChildId != childid);
          // console.log(this.siblings);

        }
      },
      error => {
        console.log(error);
      });
  }

  //------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        this.mappedData = mappedData;
        try {
          this.selectedGrade1 = 'Select Grade';
          // this.sectionList1 = mappedData[0].Sections;
          this.selectedSection1 = 'Select Section';
        } catch (error) {

        }
      },
      error => {
      });
  };



  getSectionByGrade1(grade) {
    // console.log(grade);
    this.sectionList1 = grade.Sections;
    console.log(this.sectionList1);
    try {
      this.selectedSection1 = grade.Sections[0];
      console.log(this.selectedSection1);
      this.data.StudentDetails.StandardId = this.selectedSection1.StdId;
      this.data.StudentDetails.Standard = this.selectedSection1.StdName;
      this.data.StudentDetails.SectionId = this.selectedSection1.SectionId;
      this.data.StudentDetails.Section = this.selectedSection1.sectionName;
      this.data.StudentDetails.ChildSectionId = this.selectedSection1.SectionId;

    } catch (error) {

    }
  }



  getGclClassesListById1(year, grade, section){
    console.log(year, grade, section);
    this.data.StudentDetails.SectionId = section.SectionId;
    this.data.StudentDetails.Section = section.sectionName;
    this.data.StudentDetails.ChildSectionId = section.SectionId;
  }


  private Inactive() {
    this.data.StudentDetails.Inactivestudent = 0;
    this.updateField('editactive');
  }

  private Active() {
    this.data.StudentDetails.Inactivestudent = 1;
    this.updateField('editactive');
  }

  deleteImage() {
    this.data.StudentDetails.StudentImageLink = null;
    this.updateField('StudentImageFile');
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/student-details/student-profile/student-profile.component.ts